import { Tooltip } from 'antd';
import {InfoCircleOutlined }from "@ant-design/icons";

const Tooltipoutlier = () => (
  <Tooltip title=" Data type - Object and Date are not be allowed">
    <span><InfoCircleOutlined /></span>
  </Tooltip>
);

export default Tooltipoutlier;